export default __webpack_public_path__ + "static/events-dark-c15dd87c3ca585823ed4274b705386db.png";